import styled from 'styled-components';

export const ChecklistCard = styled.div`
  background-color: ${(props) => props.theme.color.bg.primary};
  border: 1px solid ${(props) => props.theme.color.ui.shade2};
  border-radius: 3px;
  padding: 20px 24px;
  margin-bottom: 24px;
`;

export const ChecklistHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ChecklistTitle = styled.h4`
  color: ${(props) => props.theme.color.ui.orange};
  font-weight: 700;
  margin: 0;
`;

export const DismissButton = styled.button`
  border: none;
  background: transparent;
  color: ${(props) => props.theme.color.text.quaternary};
  cursor: pointer;
  line-height: 1;
  padding: 4px;

  &:hover {
    color: ${(props) => props.theme.color.text.primary};
  }
`;

export const ProgressTrack = styled.div`
  height: 8px;
  border-radius: 3px;
  background-color: ${(props) => props.theme.color.ui.shade2};
  margin: 12px 0 16px;
  overflow: hidden;
`;

export const ProgressFill = styled.div<{ $pct: number }>`
  height: 100%;
  width: ${(props) => Math.round(props.$pct * 100)}%;
  background-color: ${(props) => props.theme.color.ui.orange};
  border-radius: 3px;
  transition: width 0.4s ease;
`;

export const StepRow = styled.div<{ $done: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;

  & + & {
    border-top: 1px solid ${(props) => props.theme.color.ui.shade1};
  }
`;

export const StepIconBox = styled.div<{ $done: boolean }>`
  display: flex;
  align-items: center;
  color: ${(props) =>
    props.$done
      ? props.theme.color.ui.orange
      : props.theme.color.text.disabled};
  flex-shrink: 0;
`;

export const StepBody = styled.div`
  flex: 1;
  min-width: 0;
`;

export const StepTitle = styled.p<{ $done: boolean }>`
  margin: 0;
  font-weight: 600;
  color: ${(props) =>
    props.$done
      ? props.theme.color.text.disabled
      : props.theme.color.text.primary};
  text-decoration: ${(props) => (props.$done ? 'line-through' : 'none')};
`;

export const StepHint = styled.p`
  margin: 2px 0 0;
  font-size: 13px;
  color: ${(props) => props.theme.color.text.quaternary};
`;

export const StepAction = styled.button`
  border: none;
  border-radius: 3px;
  background-color: ${(props) => props.theme.color.ui.orange};
  color: ${(props) => props.theme.color.text.inverse};
  font-weight: 600;
  font-size: 14px;
  padding: 8px 16px;
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    filter: brightness(0.95);
  }

  @media only screen and (max-width: 576px) {
    padding: 6px 10px;
    font-size: 13px;
  }
`;

// Link discreto "Ver como fazer" → tutorial correspondente na Ajuda
export const HelpLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  font-size: inherit;
  color: ${(props) => props.theme.color.ui.orange};
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    filter: brightness(0.85);
  }
`;
